import { Maybe } from '@vimeo/core/types/generic';

import {
  EQuestionState,
  IQnAQuestion,
  TQnAQuestionReplies,
} from '../../../../types/interaction_tools';

/**
 * todo: Move to manager utils, not global-level.
 *
 * @param question - target question to check
 * @returns whether new reply can be submitted for the question
 */
export function canReplyQuestion(question: Maybe<IQnAQuestion>): boolean {
  return Boolean(question && question.state !== EQuestionState.ARCHIVED);
}

/**
 * todo: Move to manager utils, not global-level.
 *
 * @param replies - target replies collection to check
 * @returns whether question replies collection is not empty
 */
export function hasQuestionReplies(replies: Maybe<TQnAQuestionReplies> = null): boolean {
  return Boolean(replies && Object.keys(replies).length > 0);
}
